import { render, staticRenderFns } from "./ListUserPage.vue?vue&type=template&id=00dbc922"
import script from "./ListUserPage.vue?vue&type=script&lang=js"
export * from "./ListUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports